import {getRoleEntity} from '../helpers';

let initRoles = (nga) => {
    let entity = getRoleEntity(nga);
    let userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person'))
        .targetField(nga.field('full_name')).remoteComplete(true, {searchQuery: (search) => {return {full_name__icontains: search}}});
    let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}});
    const roleTypesField = nga.field('role_type', 'reference').targetEntity(
        nga.entity('references_role').identifier(nga.field('code'))
      ).targetField(nga.field('name')).validation({required: true});
    entity.listView().title('Role list').fields([
      nga.field('id').isDetailLink(true),
      nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('email')),
      nga.field('disabled_at', 'unixtime').map(value => value && (value / 1000)),
      nga.field('subscription_id', 'reference').label('Subscription')
        .targetEntity(nga.entity('subscription')).targetField(nga.field('name')),
      nga.field('role_type_str').label('Role Type'),
      nga.field('service_type_str').label('Service type'),
     ]).filters([
       userField.pinned(true),
       subscriptionField.pinned(true),
    ]).actions(['create', 'filter', 'delete']);
    entity.creationView().title('Create role').fields([
      userField,
      subscriptionField,
      roleTypesField,
      nga.field('service_type', 'choice').label('Service type').choices([
          {label: 'Realtime', value: 1},
          {label: 'SoMeIndex', value: 2}
      ])
    ]);
    entity.showView().title('View role').fields([
      userField,
      subscriptionField,
      nga.field('role_type_str').label('Role Type'),
      nga.field('service_type_str').label('Service type'),
    ]);
    entity.deletionView()

    return entity;
}

export {initRoles};



// WEBPACK FOOTER //
// ./client/app/entities/security.js